<template>
  <v-select2
    :value="value"
    :multiple="multiple"
    @input="(val) => $emit('input', val)"
    :data-ajax--url="ajaxUrl"
    data-minimumInputLength="0"
    :data-allow-clear="false"
  />
</template>

<script>
import vSelect2 from '../vSelect2';

export default {
  name: 'GuestBusinessUnitsSelector',
  components: { vSelect2 },
  props: {
    value: {},
    multiple: { type: Boolean, default: false },
    only_presents: { type: Boolean, default: false },
  },
  computed: {
    ajaxUrl() {
      let baseUrl = '/it/guest_business_units/autocomplete_guest_firstname?search=true';
      if (this.only_presents) {
        baseUrl += '&presents=true';
      }
      return baseUrl;
    },
  },
};
</script>
